import formatMessage from 'format-message';
import {IntlProvider as ReactIntlProvider} from 'react-intl';
import {connect} from 'react-redux';
import {mergedMessagesByLocale} from './locale-utils';

let configuredLocale = null;

const configureFormatMessage = locale => {
    if (configuredLocale === locale) return;

    formatMessage.setup({
        locale,
        translations: mergedMessagesByLocale,
        missingTranslation: 'ignore'
    });
    configuredLocale = locale;
};

const mapStateToProps = state => {
    configureFormatMessage(state.locales.locale);

    return {
        key: state.locales.locale,
        locale: state.locales.locale,
        messages: state.locales.messages
    };
};

export default connect(mapStateToProps)(ReactIntlProvider);
